import { render, staticRenderFns } from "./PuzzleLoopForm.vue?vue&type=template&id=2887da7a&"
import script from "./PuzzleLoopForm.vue?vue&type=script&lang=js&"
export * from "./PuzzleLoopForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports